// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_93444fe79c--pagination--VL341","pages-list":"_93444fe79c--pages-list--gsEUE","page":"_93444fe79c--page--tTWIr"};